import React, {useState} from 'react';

import {assertAndContinue} from 'Asserts';
import {BioentitySummary} from 'folder-items/FileConstants';
import BioentitySearchInput from 'inventory/BioentitySearchInput';
import OperatorDropdown from 'search/filters/base/OperatorDropdown';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {FilterKey, MultiValueFilter, Operator} from 'search/SearchConstants';
import {SearchContext} from 'search/SearchConstants';
import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface IngredientsFilter extends MultiValueFilter {
  key: FilterKey.INGREDIENTS;
}
interface IngredientsFilterFormProps extends BaseFilterFormProps {
  filter: IngredientsFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: IngredientsFilter) => void;
  onRemove: () => void;
  operators: Array<Operator>;
}

export default function IngredientsFilterForm(props: IngredientsFilterFormProps): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const [selectedItems, setSelectedItems] = useState<Array<Item>>(
    props.filter.value.map((id: string) => ({id}))
  );

  const operatorDropdown = (
    <OperatorDropdown
      buttonSize={props.buttonSize}
      onChangeOperator={(operator: Operator) => {
        props.onChangeFilter({...props.filter, operator});
      }}
      operators={props.operators}
      selectedOperator={props.filter.operator}
    />
  );
  const ingredientBioentitiesInput = (
    <BioentitySearchInput
      onChange={(bioentities: Array<BioentitySummary>) => {
        setSelectedItems(bioentities);
        props.onChangeFilter({...props.filter, value: bioentities.map((bioentity) => bioentity.id)});
      }}
      selectedItems={selectedItems}
      shouldAllowMultiple={true}
      context={SearchContext.LISTING}
    />
  );

  assertAndContinue(
    props.filterStyle === FilterStyle.SECONDARY,
    'Ingredients filter is only configured to work as a secondary filter'
  );
  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[operatorDropdown], [ingredientBioentitiesInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove}
    />
  );
}
